<!--
 * @Author: your name
 * @Date: 2021-05-20 10:15:19
 * @LastEditTime: 2024-04-17 15:18:38
 * @LastEditors: dyl
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-check/check/_components/dialog/TaskDetailDialog.vue
-->
<template>
  <div class="modal-window">
    <div class="flex">
      <section class="form" style="width: 94%; margin-bottom: 10px !important">
        <w-form label-width="80px" label-align="right" size="small">
          <w-row>
            <w-col v-if="selectZkjb" :span="4">
              <w-form-item label="质控级别:" label-width="120px">
                <w-select
                  ref="select"
                  v-model="form.ZKJB"
                  placeholder="请选择"
                  style="width: 100%"
                  disabled
                >
                  <w-option
                    v-for="item in zkjbOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </w-option>
                </w-select>
              </w-form-item>
            </w-col>
            <w-col v-if="selectZkjb" :span="4">
              <w-form-item label="督查部门:" label-width="120px">
                <w-select
                  ref="select"
                  v-model="form.ORGID"
                  placeholder="请选择"
                  style="width: 100%"
                  disabled
                >
                  <w-option
                    v-for="item in orgIdArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </w-option>
                </w-select>
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <!-- 这个是查看的组件，只做数据展示即可-->
              <w-form-item label="受检科室:" label-width="120px">
                <w-input :value="form.SJKSMC" readonly></w-input>
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <!-- 开始检查时 不允许编辑 现在组件disabled功能不支持 -->
              <w-form-item label="检查表单:" label-width="120px">
                <w-input :value="form.JCBDMC" readonly></w-input>
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <w-form-item label="督查时间:" label-width="120px">
                <w-date-picker
                  v-model="form.DCSJ"
                  type="date"
                  format="yyyy-MM-dd"
                  placeholder="请选择"
                  :disabled="type === 'view'"
                  class="width-100"
                ></w-date-picker>
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <w-form-item label="检查者:" label-width="120px">
                <w-input v-model="form.JCZ" readonly></w-input>
              </w-form-item>
            </w-col>
          </w-row>
          <w-row v-show="moreVisiable" class="mt-4">
            <w-col :span="12">
              <w-form-item label="被查护士:" label-width="120px">
                <w-input v-model="form.BCHSMC" readonly></w-input>
              </w-form-item>
            </w-col>
            <w-col :span="TSHCB === '1' ? 6 : 12">
              <w-form-item label="其他检查者:" label-width="120px">
                <w-input v-model="form.QTJCZMC" readonly></w-input>
              </w-form-item>
            </w-col>
            <w-col v-if="TSHCB === '1'" :span="6">
              <w-form-item label="权重:" label-width="120px">
                <w-input
                  v-model="form.HCB_QZ"
                  class="width-230"
                  style="width: 80%"
                  readonly
                ></w-input>
                <span style="margin-left: 5px">%</span>
              </w-form-item>
            </w-col>
          </w-row>
          <w-row v-show="moreVisiable" class="mt-4">
            <w-col :span="12">
              <w-form-item label="被查患者:" label-width="120px">
                <w-input v-model="form.BCHZMC" readonly></w-input>
              </w-form-item>
            </w-col>
            <w-col v-if="xtmj1250 == '1'" :span="12">
              <w-form-item label="受检人/次数:" label-width="120px">
                <w-input v-model="form.SJRCS" readonly></w-input>
              </w-form-item>
            </w-col>
          </w-row>
          <w-row v-show="moreVisiable" class="mt-5">
            <w-col :span="12">
              <w-form-item label="备注信息:" label-width="120px">
                <w-input
                  v-model="form.MEMO"
                  type="textarea"
                  style="width: 100%"
                  :rows="2"
                  readonly
                ></w-input>
              </w-form-item>
            </w-col>
            <w-col v-if="isMustReform" :span="3">
              <w-checkbox
                v-model="form.SFBXZG"
                disabled
                style="margin-left: 40px; top: 5px"
                >表单必须整改</w-checkbox
              >
              <div
                v-if="
                  isShowHGSCheck && groupLeader != null && groupLeader != ''
                "
                class="leader"
              >
                <span>检查组长：</span>
                <span>{{ groupLeader }}</span>
              </div>
            </w-col>
            <w-col v-if="showBatchInfo" :span="4">
              <w-row :span="4">
                <i
                  v-if="showPrevious"
                  class="w-icon-back"
                  style="
                    cursor: pointer;
                    font-weight: bolder;
                    color: blue;
                    margin-left: 5px;
                  "
                  title="上一份检查"
                  @click="previousCheck"
                ></i>
                <w-input
                  v-model="jdxx"
                  style="width: 55px; margin-left: 3px"
                  readonly
                ></w-input>
                <i
                  v-if="showNext"
                  class="w-icon-forward"
                  style="
                    margin-left: 3px;
                    cursor: pointer;
                    font-weight: bolder;
                    color: blue;
                  "
                  title="下一份检查"
                  @click="nextCheck"
                ></i>
              </w-row>
            </w-col>
            <template v-if="isShowHGSCheck">
              <w-col :span="isMustReform ? 3 : 4">
                <w-form-item label="抽检数:">
                  <w-input
                    v-model="form.BFZSLJC_CJS"
                    style="width: 100px"
                    readonly
                  ></w-input>
                </w-form-item>
              </w-col>
              <w-col :span="isMustReform ? 3 : 4">
                <w-form-item label="合格数:" label-width="120px">
                  <w-input
                    v-model="form.BFZSLJC_HGS"
                    style="width: 100px"
                    readonly
                  ></w-input>
                </w-form-item>
              </w-col>
              <w-col :span="isMustReform ? 3 : 4" class="cjs">
                <span>抽检合格率：</span>
                <span>{{ form.BFZSLJC_HGL }}%</span>
              </w-col>
            </template>
            <div
              v-if="!isShowHGSCheck && groupLeader != null && groupLeader != ''"
              class="leaders"
            >
              <span class="lea">检查组长：</span>
              <span>{{ groupLeader }}</span>
            </div>
          </w-row>
        </w-form>
      </section>
      <div
        :class="[moreVisiable ? 'moreVisiable' : '', 'collapse']"
        @click="changeCollapse"
      >
        <i
          :class="moreVisiable ? 'w-icon-arrow-top' : 'w-icon-arrow-bottom'"
        ></i>
        {{ moreVisiable ? '隐藏' : '更多' }}
      </div>
    </div>
    <w-row class="info mb-10">
      <w-col :span="3" style="display: flex">
        表单版本：<span class="fz-16 form-version" :title="form.BBH">{{
          form.BBH
        }}</span>
      </w-col>
      <w-col :span="3">
        表单类型：<span class="fz-16"> {{ calculationFuc }}</span>
      </w-col>
      <w-col :span="18" class="text-right">
        <span v-for="item in resultCheckList" :key="item.key" class="ml-20">
          {{ item.name }}:
          <span class="high-color" v-if="item.key == 'ZDF'">
            {{ `${scoreInfo.ZDF ? scoreInfo.ZDF : 0}分` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'DFL'">
            {{ `${scoreInfo.DFL ? scoreInfo.DFL : 0}%` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'WCL'">
            {{ `${scoreInfo.WCL}%` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'LSL'">
            {{ `${scoreInfo.LSL}%` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'BDZF'">
            {{
              `${
                (BDZF ? BDZF : 100) + (checkTypeInfo.JCFS == 1022 ? '分' : '%')
              }`
            }}
          </span>
          <span class="high-color" v-else-if="item.key == 'ZKF'">
            {{
              `${
                (scoreInfo.ZKF ? scoreInfo.ZKF : 0) +
                (checkTypeInfo.JCFS == 1022 ? '分' : '%')
              }`
            }}
          </span>
          <span class="high-color" v-else-if="item.key == 'WSJF'">
            {{
              `${
                (scoreInfo.WSJF ? scoreInfo.WSJF : 0) +
                (checkTypeInfo.JCFS == 1022 ? '分' : '%')
              }`
            }}
          </span>
          <span class="high-color" v-else-if="checkTypeInfo.JCFS == 1024">
            {{
              `${
                scoreInfo.ItemPrecentList.find((i) => i.JGDM == item.key)
                  ? scoreInfo.ItemPrecentList.find((i) => i.JGDM == item.key)
                      .YBZB
                  : '0'
              }`
            }}
          </span>
        </span>
        <more-cols
          class="wn-fr"
          style="margin-left: 20px"
          :show-table-col-list="resultItemColumns"
          :show-table-check-list.sync="resultCheckList"
          @getLastCheckList="checkListChange"
        ></more-cols>
      </w-col>
    </w-row>
    <vxe-table
      class="checkTables"
      v-win-loading="tableLoading"
      border
      :key="checkTableKey"
      :height="tableHeight"
      :scroll-y="{ enabled: false }"
      :span-method="rowspanMethod"
      :data="tableData"
      style="width: 100%"
      show-overflow-tooltip
      cell-class-name="radioColor"
    >
      <vxe-column key="XMDM" field="XMDM" title="项目">
        <template #header>
          <more-cols
            v-if="tableData.length > 0"
            class="wn-fr"
            style="margin-left: 20px"
            :show-table-col-list="tableColumns"
            :show-table-check-list.sync="showTableCheckList"
            @getLastCheckList="getLastCheckList"
          ></more-cols>
          <span style="margin-right: 40px">项目</span>
        </template>
        <template #default="{ row }" align="left">
          <span :class="row.SFXSQX ? 'font-red' : ''" :id="row.XMDM">{{
            row.XMMC
          }}</span>
        </template>
      </vxe-column>
      <vxe-column key="BZDM" field="BZDM" title="质量标准">
        <template #default="{ row, $rowIndex }" align="left">
          <span :id="row.BZDM" :class="[row.SFXSQX ? 'font-red' : '']">{{
            row.BZMC
          }}</span>
          <div v-if="row.IsConfilict === 1" class="more_content">
            <w-button
              class="more_btn"
              type="text"
              @click="seeDetail(row, $rowIndex)"
              >查看打分细节</w-button
            >
          </div>
        </template>
      </vxe-column>
      <vxe-column
        v-if="this.isShowKFBZ"
        key="KFMC"
        field="KFMC"
        title="扣分标准"
        align="left"
      >
        <template #default="{ row }" align="left">
          <div
            :id="rowspanMethod.KFDM"
            class="flex"
            style="justify-content: space-between"
          >
            <span
              class="ml"
              :class="row.SFXSQX ? 'font-red ' : ''"
              :style="{
                display: 'inline-block',
                width: row && row.DCJC === 1 ? '80%' : '100%'
              }"
            >
              <w-tooltip
                v-if="
                  checkTypeInfo.JCFS === 1022 &&
                  row.YPFJBS > 0 &&
                  row.YPFJBS !== '1221'
                "
                :content="row.YPFJBSMC"
                placement="top-start"
              >
                <span
                  v-if="
                    checkTypeInfo.JCFS === 1022 &&
                    row.YPFJBS > 0 &&
                    row.YPFJBS !== '1221'
                  "
                  slot="reference"
                  class="hasIcon"
                >
                </span>
              </w-tooltip>
              {{ row.KFMC }}
            </span>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        v-if="checkTypeInfo.JCFS !== 1024"
        key="KFFZ"
        field="KFFZ"
        title="分值"
        width="60"
        align="center"
      />

      <template v-if="checkTypeInfo.JCFS !== 1024 && xtmj1186 && bd1186">
        <vxe-column
          key="ZRS"
          field="ZRS"
          title="总数"
          width="70"
          align="center"
        >
          <template #default="{ row }">
            <w-input v-model="row.ZRS" disabled></w-input>
          </template>
        </vxe-column>
        <vxe-column
          key="HGS"
          field="HGS"
          title="合格数"
          width="70"
          align="center"
        >
          <template #default="{ row }">
            <w-input v-model="row.HGS" disabled></w-input>
          </template>
        </vxe-column>
        <vxe-column
          key="BHGS"
          field="BHGS"
          title="不合格数"
          width="80"
          align="center"
        >
          <template #default="{ row }">
            <w-input v-model="row.BHGS" disabled></w-input>
          </template>
        </vxe-column>
        <vxe-column
          key="DXHGL"
          field="DXHGL"
          title="合格率"
          width="70"
          align="center"
        >
          <template #default="{ row }">
            <span v-if="row.DXHGL || row.DXHGL === 0">{{
              Number((row.DXHGL * 100).toFixed(2)) + '%'
            }}</span>
          </template>
        </vxe-column>
      </template>

      <vxe-column
        v-if="isHGL === '0'"
        key="KFJG"
        field="KFJG"
        :width="
          checkTypeInfo.JCFS === 1022
            ? checkTypeInfo.KFFS == 1261
              ? 120
              : 100
            : checkTypeInfo.JCFS === 1024 && isCrosswise
            ? checkWidth
            : 200
        "
        align="center"
      >
        <!-- :class="row.KFJG ? 'red-item' : ''" -->
        <template #header="{}">
          <div class="WSJContainer">
            <span style="padding-right: 10px">{{
              checkTypeInfo.JCFS !== 1024 ? '扣加分' : '结果'
            }}</span>
            <w-checkbox
              v-if="checkTypeInfo.JCFS === 1024"
              v-model="isCrosswise"
              @change="handleChangeCrosswise"
              >是否横排</w-checkbox
            >
          </div>
        </template>
        <template #default="{ row }">
          <span v-if="checkTypeInfo.JCFS === 1022">
            <table>
              <tr>
                <td>
                  <w-input v-model="row.KFJG" readonly size="small"></w-input>
                </td>
                <td
                  v-if="checkTypeInfo.KFFS == 1261"
                  style="white-space: nowrap; width: 30%"
                >
                  {{ row.XXJGMC }}
                </td>
              </tr>
            </table>
          </span>
          <span v-else>
            <w-radio-group
              v-model="row.KFJG"
              :class="isCrosswise ? 'flex-content' : ''"
              disabled
            >
              <w-radio
                v-for="ck in checkResultList"
                :key="ck.JGDM"
                style="display: block; text-align: left; margin: 5px 5px"
                size="small"
                :class="ck.JGDM ? 'red-item' : ''"
                :label="ck.JGDM"
                ><span :style="{ color: `${ck.Color} !important` }">{{
                  ck.JGMC
                }}</span></w-radio
              >
            </w-radio-group>
          </span>
        </template>
      </vxe-column>
      <!-- 特殊核查表检查 -->
      <vxe-column
        v-if="isHGL === '1' && xtmj1250 == '1'"
        title="受检人/次数"
        width="100"
      >
        <template slot-scope="scope">
          {{ form.SJRCS ? scope.row.SJRCS : null }}
        </template>
      </vxe-column>
      <vxe-column
        v-if="isHGL === '1'"
        key="JGDM"
        :width="isCrosswise ? 150 + HCBJGListLength * 80 : '300'"
        align="center"
      >
        <template #header="{}">
          <div class="WSJContainer">
            <span style="padding-right: 10px">{{
              isShowPercentage == '1' ? '结果&样本' : '结果&样本&占比情况'
            }}</span>
            <w-checkbox v-model="isCrosswise" @change="handleChangeCrosswise"
              >是否横排</w-checkbox
            >
          </div>
        </template>
        <template #default="{ row }">
          <template v-if="!isCrosswise">
            <div v-for="list in row.HCBJGList" :key="list.JGDM" class="flex">
              <span class="w50" :style="{ color: list.Color }">{{
                list.JGMC
              }}</span>
              <w-input
                v-model.number="list.YBSL"
                class="w30"
                readonly
              ></w-input>
              <span v-if="isShowPercentage != '1'" class="w20">{{
                Number(((list.YBZB > 1 ? 1 : list.YBZB) * 100).toFixed(2)) + '%'
              }}</span>
            </div>
          </template>
          <div v-else class="flex">
            <div
              v-for="list in row.HCBJGList"
              :key="list.JGDM"
              class="flex-cloumn"
            >
              <div class="w100" :style="{ color: list.Color }">
                {{ list.JGMC }}
              </div>
              <div class="flex-center">
                <w-input
                  v-model.number="list.YBSL"
                  class="w50"
                  readonly
                ></w-input>
                <span
                  v-if="isShowPercentage != '1'"
                  class="w50"
                  style="padding-left: 5px"
                >
                  {{
                    Number(((list.YBZB > 1 ? 1 : list.YBZB) * 100).toFixed(2)) +
                    '%'
                  }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </vxe-column>
      <!-- v-if="TSHCB === '1'" -->
      <vxe-column
        v-if="isHGL === '1'"
        key="KGL"
        field="KGL"
        title="合格率"
        width="70"
        align="center"
      >
        <template #default="{ row }">
          <span>{{ Number((row.HGL * 100).toFixed(2)) + '%' }}</span>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('SFWSJ')"
        key="SFWSJ"
        field="SFWSJ"
        title="未涉及"
        width="70"
        align="center"
      >
        <template #default="{ row }">
          <w-checkbox
            v-model="row.SFWSJ"
            :disabled="type === 'view'"
          ></w-checkbox>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('KFYYSM')"
        key="KFYYSM"
        field="KFYYSM"
        title="扣分原因说明"
        width="240"
        align="center"
        class="kfyy"
      >
        <template #default="{ row }">
          <w-input
            v-model="row.KFYYSM"
            type="textarea"
            readonly
            placeholder="请选择扣分原因说明"
          >
          </w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="form.JCLX !== 1020 && isInclude('BCHS')"
        key="BCHS"
        field="BCHS"
        title="被查护士"
        width="150"
        align="center"
      >
        <template #default="{ row }">
          <w-input :value="row.BCHSMC" placeholder="请选择" readonly>
            <template slot="suffix">
              <i class="w-icon-template" style="font-size: 16px" />
            </template>
          </w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('ZRR')"
        key="ZRR"
        field="ZRR"
        title="责任人"
        width="150"
        align="center"
      >
        <template #default="{ row }">
          <w-input :value="row.ZRRMC" placeholder="请选择" readonly>
            <template slot="suffix">
              <i class="w-icon-template" style="font-size: 16px" />
            </template>
          </w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="form.JCLX === 1020 || (form.JCLX === 1019 && Mjdm === '1')"
        key="BCBRDM"
        field="BCBRDM"
        title="被查患者"
        width="150"
        align="center"
      >
        <template #default="{ row }">
          <w-input readonly :value="row.BCBRMC" placeholder="请选择">
            <template slot="suffix">
              <img
                class="pic-people left"
                src="@/common/assets/images/addpeople.png"
                alt="people"
              />
            </template>
          </w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('MEMO')"
        key="MEMO"
        field="MEMO"
        title="备注"
        width="160"
      >
        <template #default="{ row }">
          <w-input
            v-model="row.MEMO"
            readonly
            type="textarea"
            placeholder="请输入备注"
          ></w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('FJ')"
        key="FJ"
        field="FJ"
        title="附件"
        width="60"
        align="center"
      >
        <template #default="{ row }">
          <i
            class="w-icon-picture add-img"
            :style="{ color: row.TPSL && row.TPSL > 0 ? '#0c93b1' : 'grey' }"
            @click="handleOpenUpload(row)"
          />
          <span class="imgNum">{{ row.TPSL ? row.TPSL : '' }}</span>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-table
      v-if="hasOther"
      ref="checkTableOther"
      key="checkTableOther"
      v-win-loading="tableLoading"
      border
      :height="200"
      :scroll-y="{ enabled: false }"
      :data="otherData"
      show-overflow-tooltip
    >
      <vxe-colgroup key="FJDM" field="FJMC" align="left" title="附加项目">
        <vxe-column
          key="FJMC"
          width="600"
          field="FJMC"
          title="项目名称"
          align="left"
        >
          <!-- <template #default="{ row }" align="left">
                <w-input
                  v-model="row.XMFZ"
                  :disabled="type === '查看'"
                  type="textarea"
                  @change="calcZf(row)"
                ></w-input>
              </template> -->
        </vxe-column>
        <vxe-column
          key="FJSM"
          field="FJSM"
          title="项目说明"
          width="600"
          align="left"
        >
        </vxe-column>
        <vxe-column key="FJVal" field="FJVal" title="项目输入" align="left">
          <template #default="{ row }">
            <!-- 文本框 -->
            <w-input
              v-if="row.FJFS == 1210"
              v-model="row.FJVal"
              readonly
              placeholder="请输入内容"
              :maxlength="1000"
              show-counter
            ></w-input>
            <!-- 文本域 -->
            <w-input
              v-if="row.FJFS == 1211"
              v-model="row.FJVal"
              readonly
              type="textarea"
              placeholder="请输入内容"
              :maxlength="1000"
              show-counter
            ></w-input>
            <!-- 数字输入框 -->
            <w-input-number
              v-if="row.FJFS == 1212"
              v-model="row.FJVal"
              readonly
              :controls="false"
              :maxlength="1000"
              show-counter
            ></w-input-number>

            <!-- 单选 -->
            <w-select
              v-if="row.FJFS == 1213"
              v-model="row.FJVal"
              disabled
              style="margin-right: 20px; width: 100%"
            >
              <w-option
                v-for="item in FJOption(row)"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></w-option>
            </w-select>
            <!-- 多选 -->
            <w-select
              v-if="row.FJFS == 1214"
              v-model="row.valArr"
              readonly
              multiple
              style="margin-right: 20px; width: 100%"
            >
              <w-option
                v-for="item in FJOption(row)"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></w-option>
            </w-select>
            <!-- 日期 -->
            <w-date-picker
              v-if="row.FJFS == 1215"
              v-model="row.FJVal"
              readonly
              size="small"
              type="date"
              placeholder="请选择日期"
            ></w-date-picker>
            <!-- 时间 -->
            <w-time-picker
              v-if="row.FJFS == 1216"
              v-model="row.FJVal"
              readonly
              trigger-suffix
              placeholder="选择时间"
            ></w-time-picker>
            <!-- 日期时间 -->
            <w-date-picker
              v-if="row.FJFS == 1217"
              v-model="row.FJVal"
              readonly
              type="datetime"
              placeholder="请选择日期"
            ></w-date-picker>
          </template>
        </vxe-column>
      </vxe-colgroup>
    </vxe-table>
    <div class="modal-window-footer">
      <div style="float: left; padding: 10px 20px">
        <w-button
          v-if="changeNumber !== 0"
          type="text"
          @click="handleShowBGCS()"
          >{{ '变更次数(' + changeNumber + ')' }}</w-button
        >
      </div>
      <div v-show="!tableLoading" class="window-footer-btns">
        <w-button @click="exit()"> 取消 </w-button>
        <!-- 撤销 -->
        <w-button
          v-if="
            showBackBtn &&
            CanRevoke == '1' &&
            !readOnly &&
            isWithdraw(isDRJC, groupLeaderCode)
          "
          type="warning"
          @click="backSubmit()"
        >
          撤回
        </w-button>
        <w-button class="mr-10" @click="exportConfig()"> 配置导出列 </w-button>
        <w-dropdown class="mr-10 more-cols" trigger="click">
          <w-button>
            导出
            <i class="w-icon-arrow-bottom"></i>
          </w-button>
          <w-dropdown-menu slot="dropdown-menu">
            <w-dropdown-menu-item @click="exportForm('EXCEL')"
              >EXCEL</w-dropdown-menu-item
            >
            <w-dropdown-menu-item @click="exportForm('PDF')"
              >PDF</w-dropdown-menu-item
            >
          </w-dropdown-menu>
        </w-dropdown>
        <w-button class="mr-10" @click="print()"> 打印 </w-button>
      </div>
    </div>
    <w-modal
      :visible.sync="showExportConfig"
      :append-to-body="true"
      title="导出列名:"
      width="30%"
    >
      <w-checkbox-group v-model="columnArr">
        <w-checkbox
          v-for="item in exportColumns"
          :key="item.key"
          :disabled="item.disabled"
          :label="item.key"
          style="width: 30%; margin: 5px !important"
          >{{ item.name }}</w-checkbox
        >
      </w-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <w-button @click="exitExport">取 消</w-button>
        <w-button type="primary" @click="confirmExport">确 定</w-button>
      </span>
    </w-modal>
    <div class="arrow-tree-container" @click.stop="handleClickTree">
      <i v-if="showTree" class="w-icon-triangle-left"></i>
      <i v-if="!showTree" class="w-icon-triangle-right"></i>
    </div>
    <div class="tree-container-hide" :class="showTree ? 'tree-container' : ''">
      <div class="tree-header">
        <i class="icon-close w-icon-close" @click.stop="handleClickTree"></i>
      </div>
      <w-input
        v-model="filterText"
        placeholder="请输入内容"
        suffix-icon="w-icon-search"
        class="tree-input"
        @input="handleInputChange"
      ></w-input>
      <w-tree
        ref="filterTree"
        :data="anchorArr"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        :props="defaultProps"
        highlight-current
        :filter-node-method="filterNode"
        @current-change="handleCheckChange"
      ></w-tree>
    </div>
    <!-- 上传附件 -->
    <upload-list
      v-if="upVisible"
      :dialog-visible="upVisible"
      :upload-info="uploadInfo"
      :dialog-close="uploadDialogClose"
      is-result="1"
    />
    <more-detail
      v-if="morePopVisible"
      :dialog-visible="morePopVisible"
      :dialog-close="moreClose"
      class="morePopVisible"
      :row="moreRow"
      :show-field="showCondition"
      @conflictData="conflictData"
    >
    </more-detail>
  </div>
</template>

<script>
import { GetXTMJList } from '@/apps/modules/qc-plan/plan/_api/index'
import PdfDialog from '@/common/components/Dialog/pdfDialog.vue'
import MoreCols from '@/common/components/MoreCols'
import { getTableCheckColumns } from '@/common/utils'
import { DownFile, Print } from '@/common/utils/download'
import { mapState } from 'vuex'
import { CalcZKJCData, GetZKJCInfo } from '../../_api/index'
import UploadList from './UploadList.vue'
import MoreDetail from './MoreDetail.vue'
import BgcsDialog from './BgcsDialog.vue'
import AddTaskDialog from '../dialog/AddTaskDialog.vue'

export default {
  name: 'TaskDetailDialog',
  components: {
    UploadList,
    MoreCols,
    MoreDetail
  },
  props: {
    checkType: {
      type: String,
      default: ''
    },
    checkDetailInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 新增还是开始检查
    type: {
      type: String,
      default: ''
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    showBackBtn: {
      type: Boolean,
      default: null
    },
    selectZkjb: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      zkjbOptions: [],
      orgIdArr: [],
      UserId: '00',
      row: {},
      tableIndex: 0,
      form: {
        SJKS: '',
        SJKSMC: '',
        JCBD: '',
        JCBDMC: '',
        DCSJ: new Date(),
        JCZ: '',
        CFXH: '00', // 新增时暂时没有该字段值。 需后面对接后修改赋值
        QTJCZID: [],
        BJCZDM: [],
        MEMO: '',
        BBH: '',
        BFZSLJC_CJS: '',
        BFZSLJC_HGS: '',
        BFZSLJC_HGL: '',

        ZKJB: '',
        ORGID: '',
        SFBXZG: false
      },
      tableData: [],
      otherData: [],
      hasOther: false,
      moreVisiable: true,
      tableLoading: false,
      scoreInfo: {
        DFL: 0,
        LSL: 0,
        WCL: 0,
        ZDF: 0,
        ZKF: 0,
        WSJF: 0,
        XXZBQK: '',
        ItemPrecentList: []
      },
      BDZF: 0,
      checkResultList: [],
      checkTypeInfo: {
        JCFS: '', // id
        JCFSMC: '', // 名称
        KFFS: ''
      },
      Mjdm: '0',
      TSHCB: '0',
      isHGL: '0',
      CanRevoke: '1',
      isShowHGSCheck: false, //是否合格数检查
      showExportConfig: false,
      exportColumns: [
        {
          name: '项目',
          key: 'XMMC',
          disabled: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          disabled: true
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          disabled: false
        },
        {
          name: '分值',
          key: 'KFFZ',
          disabled: true
        },
        {
          name: '总数',
          key: 'ZRS'
        },
        {
          name: '合格数',
          key: 'HGS'
        },
        {
          name: '不合格数',
          key: 'BHGS'
        },
        {
          name: '单项合格率',
          key: 'DXHGL'
        },
        {
          name: '扣加分',
          key: 'JGMC',
          disabled: true
        },
        {
          name: '合格率',
          key: 'HGL'
        },
        {
          name: '未涉及',
          key: 'SFWSJ'
        },
        {
          name: '扣分原因说明',
          key: 'KFYYSM'
        },
        {
          name: '被查护士',
          key: 'BCHSMC'
        },
        {
          name: '责任人',
          key: 'ZRRMC'
        },
        {
          name: '被查患者',
          key: 'BCBRMC'
        },
        {
          name: '备注',
          key: 'MEMO'
        }
      ],
      columnArr: [],
      lastCloumns: [],
      anchorArr: [],
      showTree: false,
      filterText: '',
      anchorId: '',
      firstCalc: true,
      xtmj1186: false,
      bd1186: false,
      uploadInfo: {},
      upVisible: false,
      tableColumns: [
        {
          name: '未涉及',
          key: 'SFWSJ',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因说明',
          key: 'KFYYSM',
          keepChoosing: false,
          checked: true
        },
        {
          name: '被查护士',
          key: 'BCHS',
          keepChoosing: false,
          checked: true
        },
        {
          name: '责任人',
          key: 'ZRR',
          keepChoosing: false,
          checked: true
        },
        {
          name: '备注',
          key: 'MEMO',
          keepChoosing: false,
          checked: false
        },
        {
          name: '附件',
          key: 'FJ',
          keepChoosing: false,
          checked: true
        }
      ],
      resultItemColumns: [
        {
          name: '总得分',
          key: 'ZDF',
          keepChoosing: true,
          checked: true
        },
        {
          name: '得分率',
          key: 'DFL',
          keepChoosing: false,
          checked: false
        },
        {
          name: '落实率',
          key: 'LSL',
          keepChoosing: false,
          checked: false
        },
        {
          name: '完成率',
          key: 'WCL',
          keepChoosing: false,
          checked: false
        },
        {
          name: '表单总分',
          key: 'BDZF',
          keepChoosing: false,
          checked: false
        },
        {
          name: '总扣分',
          key: 'ZKF',
          keepChoosing: false,
          checked: false
        },
        {
          name: '未涉及分',
          key: 'WSJF',
          keepChoosing: false,
          checked: false
        }
      ],
      resultCheckList: [],
      showTableCheckList: [],
      isMustReform: true, //表单必须整改
      isShowKFBZ: true,
      morePopVisible: false, //开启打分详情弹窗
      moreRow: [],
      showCondition: {
        TSHCB: '0',
        isHGL: '0',
        JCFS: 0,
        checkResultList: [],
        JCLX: '',
        Mjdm: '0'
      },
      groupLeader: '',
      groupLeaderCode: '0',
      cloneTable: [],
      isDRJC: false,
      xtmj1250: '0',
      isShowPercentage: 0, //是否展示占比情况
      batchList: [],
      currentCfxh: 0,
      jdxx: '',
      showBatchInfo: false,
      showNext: true,
      showPrevious: true,
      isCrosswise: false,
      HCBJGListLength: 1,
      checkTableKey: Math.random()
    }
  },
  computed: {
    ...mapState('check', ['Zkjb']),
    //计算表格高度
    tableHeight() {
      // 150  展开时更多时。  60 得分信息  50  底部按钮高度
      return (
        window.innerHeight -
        (this.moreVisiable ? 200 : 100) -
        60 -
        50 -
        (this.hasOther ? 200 : 0)
      )
    },
    // 展示计算方式
    calculationFuc() {
      let strs = ''
      if (this.type === 'add') {
        strs = this.checkTypeInfo.JCFSMC
      } else {
        strs = this.rowData.JCFS_MC ? this.rowData.JCFS_MC : ''
      }
      return strs
    },
    changeNumber: {
      get() {
        return this.rowData && this.rowData.BGCS ? this.rowData.BGCS : 0
      },
      set(newValue) {
        this.rowData.BGCS = newValue
      }
    },
    checkWidth() {
      return 120 + this.checkResultList.length * 50
    }
  },

  created() {
    if (this.selectZkjb) {
      this.getZKJB()
    }
    let JCFS = this.rowData.JCFS
    this.getSysTemSetting(JCFS)

    if (this.rowData.JCFS === 1024) {
      this.exportColumns.splice(3, 1)
    }
    this.columnArr = this.exportColumns.map((item) => {
      return item.key
    })
    if (localStorage.getItem('columnArr')) {
      this.columnArr = JSON.parse(localStorage.getItem('columnArr'))
    }
    this.showTableCheckList = getTableCheckColumns(
      `addDialog${this.rowData.CFXH}`,
      this.tableColumns
    )
    this.isCrosswise =
      sessionStorage.getItem('IS_CROSSWISE') === 'true' || false
  },

  mounted() {
    this.BDZF = this.rowData.BDZF || 100

    if (this.selectZkjb) {
      this.form.ZKJB = this.rowData.ZKJB ? this.rowData.ZKJB + '' : ''
      this.form.ORGID = this.rowData.ORGID ? this.rowData.ORGID + '' : ''
    }

    let JudgeArray = {
      1001: '-1112_3',
      1002: '-1112_2',
      1003: '-1112_1'
    }

    if (this.form.ORGID.includes(1112)) {
      this.form.ORGID = JudgeArray[`${this.form.ZKJB}`]
        ? JudgeArray[`${this.form.ZKJB}`]
        : ''
    }

    const { CFXH } = this.rowData

    this.$requestApi('GetZKJCByCFXH', {
      Cfxh: CFXH
    }).then((res) => {
      if (res.data && res.data[0]) {
        let mxjcData = res.data[0]
        const {
          JCFW_DM,
          JCFW_MC,
          ZZ,
          ZZMC,
          ZY,
          ZYMC,
          JCXM_MC,
          JCXM_DM,
          CJSJ,
          BJCZMC,
          BJCZDM,
          BJCZXX,
          BCHSMC,
          BCBRMC,
          JCFS,
          JCFS_MC,
          JCLX,
          MEMO,
          BBH,
          HCB_QZ,
          SJRCS,
          KFFS
        } = mxjcData

        this.form.SJRCS = SJRCS
        this.form.SJKS = JCFW_DM + ''
        this.form.SJKSMC = JCFW_MC
        this.form.JCBD = JCXM_DM
        this.form.JCBDMC = JCXM_MC
        this.form.JCZ = ZZMC
        this.form.QTJCZID = ZY ? ZY.split(',') : [] // 其他检查者
        this.form.QTJCZMC = ZYMC
        this.form.BJCZMC = BJCZMC ? BJCZMC.replaceAll(' ', '') : ''
        this.form.BJCZDM = BJCZDM ? BJCZDM.split(',') : [] // 被检查护士

        this.form.BCHSMC = BCHSMC
        this.form.BCHZMC = BCBRMC

        this.form.CFXH = CFXH
        this.form.JCFS = JCFS
        this.form.JCLX = JCLX
        if (this.form.JCLX == 1020) {
          this.tableColumns = this.tableColumns.filter((x) => {
            return x.key != 'BCHSMC'
          })
        }
        this.form.MEMO = MEMO
        this.form.BBH = BBH
        this.form.DCSJ = this.rowData.JCSJ
        this.checkTypeInfo = {
          JCFS,
          JCFSMC: JCFS_MC,
          KFFS: KFFS
        }
        this.form.HCB_QZ = HCB_QZ

        this.scoreInfo.DFL = this.rowData.DFL ? this.rowData.DFL : 0
        this.scoreInfo.LSL = this.rowData.LSL ? this.rowData.LSL : 0
        this.scoreInfo.WCL = this.rowData.WCL ? this.rowData.WCL : 0
        this.scoreInfo.ZDF = this.rowData.ZDF ? this.rowData.ZDF : 0
        this.scoreInfo.ZKF = this.rowData.ZKF ? this.rowData.ZKF : 0
        this.scoreInfo.WSJF = this.rowData.WSJF ? this.rowData.WSJF : 0
        this.scoreInfo.XXZBQK = this.rowData.XXZBQK ? this.rowData.XXZBQK : ''

        // 检查表单类型为核查表时查询获取结果另存为信息
        // 需更改为根据id 判断，字段名称可能会变
        if (this.rowData.JCFS === 1024) {
          this.$requestApi('GetHCBCheckResult', {
            Bddm: this.form.JCBD || this.rowData.Bddm || this.rowData.BDDM
          }).then((res) => {
            this.checkResultList = res.data

            this.genResultOptions('1024')
          })
        } else {
          this.genResultOptions('1022')
        }
        this.getZkjcinfo()

        // 添加时需处理百分制 核查表的对应关系
        this.exportColumns.forEach((item) => {
          if (item.key == 'JGMC') {
            item.name = this.checkTypeInfo.JCFS !== 1024 ? '扣加分' : '结果'
          }
        })
      }
    })
  },
  methods: {
    isInclude(str) {
      return this.showTableCheckList.find((i) => i.key == str) ? true : false
    },
    // 将被检查者拆分为被查护士和被查患者 lx：$1 护士 $2患者
    splitToBchsAndBchz(codeArr, nameArr, lxArr) {
      let result = {
        bchs: [],
        bchz: []
      }
      let lxDic = new Map()
      if (lxArr) {
        lxArr.forEach((element) => {
          let temp = element.split('$')
          if (temp.length == 2) {
            lxDic.set(temp[0], temp[1])
          }
        })
      }

      if (codeArr && nameArr && lxArr && codeArr.length == nameArr.length) {
        codeArr.forEach((m, index) => {
          if (lxDic.get(m) == '1') {
            result.bchs.push({
              id: m,
              name: nameArr[index]
            })
          } else {
            result.bchz.push({
              id: m,
              name: nameArr[index]
            })
          }
        })
      }
      return result
    },
    getLastCheckList(val) {
      if (this.type === 'add') {
        return
      }
      if (val.length > 0) {
        localStorage.setItem(
          `addDialog${this.rowData.CFXH}`,
          JSON.stringify({
            showTableCheckList: val
          })
        )
      } else {
        localStorage.removeItem(`addDialog${this.rowData.CFXH}`)
      }
    },
    getZKJB() {
      if (this.rowData.isGzt) {
        this.$requestApi('GetAllZkjbList').then((res) => {
          if (res.success) {
            this.zkjbOptions = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id
              }
            })
            this.getCheckDepartInfo(this.form.ZKJB)
          }
        })
      } else {
        this.$requestApi('GetZkjbByUserId').then((res) => {
          if (res.success) {
            this.zkjbOptions = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id
              }
            })
            this.getCheckDepartInfo(this.form.ZKJB)
          }
        })
      }
    },
    // 获取督查部门
    getCheckDepartInfo(Zkjb) {
      if (this.rowData.isGzt) {
        this.$requestApi('GetOrgByMultiZkjb', {
          HospitalCode: this.HospitalCode,
          Zkjb: Zkjb,
          IsGzt: 1
        }).then((res) => {
          if (res.success) {
            let data = res.data.map((item) => {
              if (!item.Child) {
                return item
              }

              let child = item.Child.map((m) => {
                return {
                  ...m,
                  QYZT: m.customAttr || m.QYZT
                }
              })
              return {
                ...item,
                Child: child,
                QYZT: item.customAttr || item.QYZT
              }
            })
            let leafNode = []
            this.getAllLeafNodes(data, leafNode)
            this.orgIdArr = leafNode
          }
        })
      } else {
        this.$requestApi('GetOrg', {
          UserId: this.$store.state.user.loginUserInfo.UserId,
          HospitalCode: this.HospitalCode,
          Zkjb: Zkjb
        }).then((res) => {
          if (res.success) {
            let data = res.data.map((item) => {
              let child = []
              if (item.Childitem && item.Childitem.Child) {
                child = item.Childitem.Child.map((m) => {
                  return {
                    ...m,
                    QYZT: m.customAttr || m.QYZT
                  }
                })
              }
              return {
                ...item,
                Child: child,
                QYZT: item.customAttr || item.QYZT
              }
            })
            let leafNode = []
            this.getAllLeafNodes(data, leafNode)
            this.orgIdArr = leafNode
          }
        })
      }
    },
    calcScore(row) {
      let ZKJCModel = {
        BDDM: this.form.JCBD,
        BDMC: this.form.JCBDMC,
        CFXH: this.form.CFXH, // 新建时拆分序号暂时 无法获取到
        ZZJGDM: this.form.SJKS,
        JCZID: this.form.JCZ,
        JCZMC: this.form.ZZMC, //改变后需重新赋值
        QTJCZID: this.form.QTJCZID.join(','),
        QTJCZMC: this.form.QTJCZMC,
        IsSave: '', // 保存 / 提交
        QZXS: this.form.HCB_QZ,
        ZKJCInfoList: this.tableData, //接传递table数据
        BJCZDM: this.form.BJCZDM.join(',')
      }
      CalcZKJCData(ZKJCModel).then((res) => {
        this.scoreInfo = res.data
      })
    },
    //获取系统配置相关
    getSysTemSetting(JCFS) {
      let params = {
        Mjdm: '1186,1127,1146,1226,1134,1186,1127,1226,1134,1147,1248,1250'
      }
      GetXTMJList(params).then((res) => {
        if (res.success) {
          let data = res.data
          // 扣分标准
          if (JCFS == 1024) {
            this.isShowKFBZ = data.find((item) => item.MJDM === 1134)?.JLZT
            this.isShowKFBZ = this.isShowKFBZ === '1' ? true : false
          }
          this.Mjdm = data.find((item) => item.MJDM === 1127)?.JLZT
          this.isMustReform =
            data.find((item) => item.MJDM == 1226)?.JLZT == '1'
          if (JCFS === 1024) {
            this.TSHCB = data.find((item) => item.MJDM === 1146)?.JLZT
          } else {
            this.TSHCB = '0'
          }
          this.isShowPercentage = data.find((item) => item.MJDM == 1248)?.JLZT
          this.xtmj1147 = data.find((item) => item.MJDM === 1147)?.JLZT
          // 1186参数开启，百分制新增总数、合格数、不合格数和合格率四列
          if (data.some((item) => item.MJDM == 1186)) {
            this.xtmj1186 = data.find((item) => item.MJDM == 1186).JLZT == '1'
          }
          if (
            !(
              this.rowData.JCLX === 1020 ||
              (this.rowData.JCLX === 1019 && this.Mjdm === '1')
            )
          ) {
            this.exportColumns.pop()
          }

          if (!this.isShowKFBZ) {
            let index = this.exportColumns.findIndex((i) => i.key == 'KFMC')
            this.exportColumns.splice(index, 1)
          }
          this.xtmj1250 = data.find((item) => item.MJDM == 1250)?.JLZT
        }
      })
    },
    // 开始检查
    getZkjcinfo() {
      this.tableLoading = true
      GetZKJCInfo({
        Cfxh: this.rowData.CFXH,
        Bddm: this.rowData.JCXM_DM,
        UserId: this.$store.state.user.loginUserInfo.UserId //新增用户id,进行筛选
      }).then((res) => {
        if (res.success) {
          this.isHGL = res.data.IsHGL
          this.CanRevoke = res.data.CanRevoke
          this.form.SFBXZG = res.data.SFBXZG == 1
          this.tableLoading = false
          this.tableData = res.data.CheckList
          this.HCBJGListLength =
            this.tableData[0] && this.tableData[0].HCBJGList.length
          if (res.data.HospitalCode && this.form.ORGID.includes('-1112')) {
            this.form.ORGID = this.form.ORGID + `_${res.data.HospitalCode}`
          }
          this.batchList = res.data.PCJCList
          this.currentCfxh = this.rowData.CFXH
          if (this.batchList.length > 1) {
            this.showBatchInfo = true
          }
          //多人检查需求
          this.cloneTable = JSON.parse(JSON.stringify(res.data.CheckList))
          this.groupLeader = res.data.ZJCZMC
          this.groupLeaderCode = res.data.ZJCZ
          this.isDRJC = res.data.DRJC == 1 ? true : false
          //设置合格率
          if (this.TSHCB == '0' && this.xtmj1147 == '0') {
            this.tableData.forEach((item) => {
              if (item.HCBJGList.every((items) => items.YBSL == 0)) {
                item.HGL = 1
              }
            })
          }

          this.bd1186 = res.data.SFJL_JCRS_HGL
          if (
            this.checkTypeInfo.JCFS === 1024 ||
            !this.xtmj1186 ||
            !this.bd1186
          ) {
            let Index = this.exportColumns.findIndex((i) => i.key == 'ZRS')
            this.exportColumns.splice(Index, 4)
          }
          this.anchorArr = this.toChildrenStruct(res.data.CheckList)
          this.hasOther = res.data.FJState || false
          this.otherData =
            res.data.FJXMList && res.data.FJXMList.length > 0
              ? res.data.FJXMList.map((m) => {
                  if (m.FJFS == 1214) {
                    m.valArr = m.FJVal ? m.FJVal.split(';') : []
                  }
                  return m
                })
              : []
          this.tableData.forEach((item) => {
            item.KFJG =
              this.checkTypeInfo.JCFS === 1022 ? item.KFJG : Number(item.KFJG)
            item.SFWSJ = !!item.SFWSJ
          })
          if (this.tableData && this.tableData.length > 0) {
            this.isShowHGSCheck = this.tableData[0].BFZSLJC_ZT == 1
            this.form.BFZSLJC_CJS = this.tableData[0].BFZSLJC_CJS
            this.form.BFZSLJC_HGS = this.tableData[0].BFZSLJC_HGS
            this.form.BFZSLJC_HGL = this.tableData[0].BFZSLJC_HGL
          }
          if (
            (this.scoreInfo.LSL === 0 ||
              this.scoreInfo.WCL === 0 ||
              this.scoreInfo.DFL === 0 ||
              this.scoreInfo.ZDF === 0 ||
              this.scoreInfo.ZKF == 0 ||
              this.scoreInfo.WSJF == 0) &&
            this.firstCalc
          ) {
            this.firstCalc = false
            this.$nextTick(() => {})
          }
          if (!(this.checkTypeInfo.JCFS === 1024 && this.isHGL == '1')) {
            let index = this.exportColumns.findIndex((i) => i.key == 'HGL')
            this.exportColumns.splice(index, 1)
          }
          if (this.checkType == '3') {
            this.calcScore()
          }
        } else {
          this.tableLoading = false
        }
        this.showJdxx()
      })
    },
    genResultOptions(jcfs) {
      if (jcfs == '1024') {
        let orginResultItemColumnList = this.resultItemColumns.filter(
          (i) =>
            i.key == 'DFL' ||
            i.key == 'LSL' ||
            i.key == 'WCL' ||
            i.key == 'BDZF' ||
            i.key == 'WSJF' ||
            i.key == 'ZKF'
        )

        let dflOption = this.resultItemColumns.find((i) => i.key == 'DFL')
        dflOption.checked = true
        dflOption.keepChoosing = true

        if (this.scoreInfo.XXZBQK && this.scoreInfo.XXZBQK != '') {
          this.scoreInfo.ItemPrecentList = this.scoreInfo.XXZBQK.split(';').map(
            (i) => {
              let item = i.split(':')
              let xxObj = new Object()
              let hcbjg = this.checkResultList.find((j) => j.JGMC == item[0])

              xxObj.JGDM = hcbjg.JGDM
              xxObj.JGMC = item[0]
              xxObj.YBZB = item[1]
              return xxObj
            }
          )

          let jgxxArr = new Array()
          this.checkResultList.forEach((item) => {
            let jgx = new Object()
            jgx.key = item.JGDM
            jgx.name = item.JGMC
            jgx.keepChoosing = false
            jgx.checked = false
            jgxxArr.push(jgx)
          })
          if (jgxxArr.length > 0) {
            this.resultItemColumns = jgxxArr.concat(orginResultItemColumnList)
          }
        } else {
          this.resultItemColumns = orginResultItemColumnList
        }

        let cacheResult = localStorage.getItem(
          `seeDialog_info_${this.rowData.CFXH}`
        )
        if (cacheResult) {
          this.resultCheckList = JSON.parse(cacheResult).resultCheckList
        } else {
          this.resultCheckList = this.resultItemColumns
        }
      } else {
        this.resultItemColumns = this.resultItemColumns.filter(
          (i) =>
            i.key == 'ZDF' ||
            i.key == 'DFL' ||
            i.key == 'LSL' ||
            i.key == 'BDZF' ||
            i.key == 'WSJF' ||
            i.key == 'ZKF'
        )
        this.resultCheckList = this.resultItemColumns
      }
    },
    showJdxx() {
      let batchList = this.batchList
      let total = this.batchList.length
      let currentNo =
        total && batchList.find((i) => i.CFXH == this.currentCfxh).XSXH
      var currentIndex = this.batchList.findIndex(
        (i) => i.CFXH == this.currentCfxh
      )
      this.jdxx = currentNo + '/' + total
      this.setChangeBtn(currentIndex)
    },
    previousCheck() {
      var currentIndex = this.batchList.findIndex(
        (i) => i.CFXH == this.currentCfxh
      )
      if (currentIndex >= 1) {
        var previousCfxh = this.batchList[currentIndex - 1].CFXH
        var wcqk = this.batchList[currentIndex - 1].WCQK
        if (wcqk == '1') {
          this.type = 'check'
          this.rowData.CFXH = previousCfxh
          this.getZkjcinfo()
        } else {
          this.type = 'check'
          this.$requestApi('GetZKJCList', {
            CFXH: previousCfxh
          }).then((res) => {
            if (res.success) {
              this.$emit('close', {})
              let checkData = res.data[0]
              this.onDetail(checkData)
            }
          })
        }
      }
      this.setChangeBtn(currentIndex)
    },
    nextCheck() {
      var total = this.batchList.length
      var currentIndex = this.batchList.findIndex(
        (i) => i.CFXH == this.currentCfxh
      )
      if (currentIndex < total - 1) {
        var nextCfxh = this.batchList[currentIndex + 1].CFXH
        var wcqk = this.batchList[currentIndex + 1].WCQK
        if (wcqk == '1') {
          this.type = 'check'
          this.rowData.CFXH = nextCfxh
          this.getZkjcinfo()
        } else {
          this.type = 'check'
          this.$requestApi('GetZKJCList', {
            CFXH: nextCfxh
          }).then((res) => {
            if (res.success) {
              this.$emit('close', {})
              let checkData = res.data[0]
              this.onDetail(checkData)
            }
          })
        }
      }
      this.setChangeBtn(currentIndex)
    },
    setChangeBtn(currentIndex) {
      let total = this.batchList.length
      if (currentIndex >= 1 && currentIndex < total - 1) {
        this.showNext = true
        this.showPrevious = true
      }
      if (currentIndex == 0) this.showPrevious = false
      if (currentIndex == total - 1) this.showNext = false
    },
    onDetail(row) {
      let width = window.innerWidth * 1
      let height = window.innerHeight * 1
      let dialog = AddTaskDialog
      let params = {
        type: 'check',
        selectZkjb: this.selectZkjb,
        rowData: row,
        checkType: row.JCFS,
        listQuery: {
          ZKJB: row.ZKJB,
          ORGID: row.ORGID,
          HospitalCode: row.HospitalCode || ''
        }
      }
      const key = this.$dlg.modal(dialog, {
        width: width,
        height: height,
        title: '检查',
        params,
        callback: () => {},
        cancelCallback: () => {}
      })
    },
    // 是否折叠
    changeCollapse() {
      this.moreVisiable = !this.moreVisiable
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    rowspanMethod({ row, _rowIndex, column, visibleData }) {
      const fields = ['XMDM', 'BZDM']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    // 打开上传
    handleOpenUpload(row) {
      // uploadInfo 上传所需的信息 （url地址，所需的参数）
      this.uploadInfo = row
      if (this.type === 'view') {
        this.uploadInfo.uploadType = 'view'
        if (!(row.TPSL && row.TPSL > 0)) {
          return
        }
      }
      this.upVisible = true
    },

    //上传
    uploadDialogClose() {
      this.upVisible = false
    },
    // 取消
    exit() {
      this.$emit('close', {})
    },
    // 撤销检查完成
    backSubmit() {
      this.$Confirm('确定要将本次检查撤回吗？', '提示', {
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          let params = {
            Cfxh: this.form.CFXH
          }
          this.$requestApi('CancleZKJC', params).then((res) => {
            if (res.success) {
              this.$emit('close', { success: true })
            }
          })
        })
        .catch(() => {})
    },
    exitExport() {
      this.showExportConfig = false
      this.columnArr = this.lastCloumns
    },
    confirmExport() {
      this.showExportConfig = false
      localStorage.setItem('columnArr', JSON.stringify(this.columnArr))
    },
    //导出
    exportForm(fileType) {
      this.$Confirm('确定要导出该表单吗？', '提示', {
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          let ExportColumns = []
          this.exportColumns.forEach((item) => {
            if (this.columnArr.includes(item.key)) {
              ExportColumns.push(item)
            }
          })
          DownFile('NQCS/Download?act=ExportZKJCData', {
            Cfxh: this.rowData.CFXH,
            FileType: fileType,
            ExportColumns: JSON.stringify(ExportColumns)
          })
        })
        .catch(() => {})
    },
    exportConfig() {
      this.showExportConfig = true
      this.lastCloumns = this.columnArr
    },
    print() {
      let ExportColumns = []
      this.exportColumns.forEach((item) => {
        if (this.columnArr.includes(item.key)) {
          ExportColumns.push(item)
        }
      })
      const param = {
        Cfxh: this.rowData.CFXH,
        ExportColumns: JSON.stringify(ExportColumns),
        FileType: 'PDF'
      }
      Print('NQCS/Print?act=ExportZKJCData', param).then((res) => {
        let width = window.innerWidth
        let height = window.innerHeight
        const key = this.$dlg.modal(PdfDialog, {
          width: width,
          height: height,
          title: '文件打印',
          params: {
            pdfUrl: res.data.FilePath
          },
          callback: (data) => {
            if (this.isRefreshTable) {
              this.getDataList(this.listQuery)
            }
          },
          cancelCallback: () => {}
        })
      })
    },
    async handleShowBGCS() {
      const data = await this.getChangeRecordList()
      let width = window.innerWidth * 0.85
      let height = window.innerHeight * 0.8

      const key = this.$dlg.modal(BgcsDialog, {
        width: width,
        height: height,
        title: '变更记录',
        params: {
          data
        },

        callback: (data) => {},
        cancelCallback: () => {}
      })
    },
    getChangeRecordList() {
      return new Promise((resolve, reject) => {
        this.$requestApi('GetCheckChangeRecordList', {
          Cfxh: this.form.CFXH
        })
          .then((res) => {
            if (res.success) {
              this.changeNumber = res.data.RecordCount
              resolve(res.data.RecordList)
            } else {
              reject()
            }
          })
          .catch(() => {
            reject()
          })
      })
    },
    toChildrenStruct(pidArray) {
      // 将数据转换成children结构
      let childrenArray = []
      let XMArr = []
      const itemMap = {}
      if (!pidArray) {
        return childrenArray
      } else {
        for (const item of pidArray) {
          var firstItem = {
            id: item.XMDM,
            label: item.XMMC,
            children: []
          }
          if (!XMArr.includes(item.XMDM)) {
            childrenArray.push(firstItem)
          }
          XMArr.push(item.XMDM)
        }
        for (const i of childrenArray) {
          let BZArr = []
          for (const j of pidArray) {
            if (j.XMDM == i.id) {
              if (!BZArr.includes(j.BZDM)) {
                i.children.push({
                  id: j.BZDM,
                  label: j.BZMC,
                  children: []
                })
              }
              BZArr.push(j.BZDM)
            }
          }
          for (const k of i.children) {
            let KFArr = []
            for (const l of pidArray) {
              if (l.BZDM == k.id) {
                if (!KFArr.includes(l.KFDM)) {
                  k.children.push({
                    id: l.KFDM,
                    label: l.KFMC
                  })
                }
                KFArr.push(l.KFDM)
              }
            }
          }
        }
      }
      return childrenArray
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleCheckChange(val) {
      this.anchorId = val.id
      document.getElementById(val.id).scrollIntoView()
    },
    handleInputChange(val) {
      this.$refs.filterTree.filter(val)
    },
    handleClickTree() {
      if (this.showTree) {
        this.showTree = false
      } else {
        this.showTree = true
      }
      this.$nextTick(() => {
        if (this.anchorId) {
          document.getElementById(this.anchorId).scrollIntoView()
        }
      })
    },
    FJOption(row) {
      if (row.FJFSXX) {
        var arr = row.FJFSXX.split(';')
        return arr.map((m) => {
          return {
            id: m,
            lable: m
          }
        })
      }
      return []
    },
    scoreInfoResult(data) {
      //百分号过滤
      let str = `${data}`
      if (str.includes('%')) {
        return str.replace(/%/, '')
      } else {
        return str
      }
    },
    seeDetail(row, index) {
      // 查看打分详情
      this.moreRow = this.cloneTable[index].ConflictList

      // 特殊表单展示需要的条件字段
      this.showCondition.isHGL = this.isHGL
      this.showCondition.TSHCB = this.TSHCB
      this.showCondition.JCFS = this.checkTypeInfo.JCFS
      this.showCondition.checkResultList = this.checkResultList
      this.showCondition.JCLX = this.form.JCLX
      this.showCondition.Mjdm = this.Mjdm
      this.morePopVisible = true
    },
    moreClose() {
      this.morePopVisible = false
    },
    conflictData(data) {},
    isWithdraw(drcj, isLeader) {
      if (drcj == true) {
        if (
          isLeader &&
          isLeader == this.$store.state.user.loginUserInfo.UserId
        ) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
      // return drcj == true ? (isLeader!='' &&  isLeader!=null) ? true : false : true
    },
    getAllLeafNodes(nodes, leafNodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i]

        if (!node.Child || node.Child.length === 0) {
          // 当前节点没有子节点，认为是叶子节点，将其添加到数组中
          leafNodes.push(node)
        } else {
          // 遍历子节点
          this.getAllLeafNodes(node.Child, leafNodes)
        }
      }
    },
    handleChangeCrosswise(val) {
      sessionStorage.setItem('IS_CROSSWISE', val)
      this.checkTableKey = Math.random()
    },
    checkListChange(val) {
      if (val.length > 0) {
        localStorage.setItem(
          `seeDialog_info_${this.rowData.CFXH}`,
          JSON.stringify({
            resultCheckList: val
          })
        )
      } else {
        localStorage.removeItem(`seeDialog_info_${this.rowData.CFXH}`)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-bottom: 20px;
}
.collapse {
  width: 10%;
  color: var(--COLOR-NORMAL);
  cursor: pointer;
  text-align: center;
  position: relative;
  top: -10px;
  i {
    margin-right: 4px;
  }
}
.moreVisiable {
  position: relative;
  top: -30px;
}
.w50 {
  width: 50%;
  text-align: left;
}
.w30 {
  width: 30%;
}
.w20 {
  width: 30%;
  text-align: right;
}
.info {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  background-color: #f1f1ee;
  border-radius: 5px;
  min-height: 50px;
  line-height: 28px;
}
.high-color {
  color: #f00909;
  font-size: 18px;
  font-weight: 600;
}
.modal-window-footer {
  border-top: 1px solid #f1f1ee;
  width: 100%;
  margin-right: 15px;
}
.pic-people {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.add-img {
  font-size: 22px;
  cursor: pointer;
  position: relative;
}

.add-img::after {
  content: '';
  position: absolute;
  left: -20px;
  top: -15px;
  right: -20px;
  bottom: -15px;
}
.width-100 {
  width: 120%;
  max-width: 220px;
}
.font-red {
  color: red;
}

/deep/ .red-item {
  .w-input__inner {
    color: red !important;
  }
  // .w-radio__label {
  //   color: red !important;
  // }
}
/deep/ .tree-container-hide {
  display: none;
  border: 1px solid #c9c9c9;
  position: fixed;
  top: 250px;
  background-color: #fff;
  left: 16px;
  width: 300px;
  overflow-x: hidden;
  // transform: translateX(-200%);
  z-index: -1;
  .tree-header {
    height: 24px;
    background-color: #eaeefe;
    .icon-close {
      line-height: 24px;
      float: right;
    }
  }
  .tree-input {
    margin: 5px;
    width: calc(100% - 10px);
  }
  .w-tree {
    height: 580px;
    overflow: auto;
    .w-tree-node__label {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.tree-container {
  z-index: 999;
  display: block !important;
  // transform: translateX(0);
  // transition-duration: 0.5s;
}
/deep/ .tree-container-hide {
  border: 1px solid #c9c9c9;
  position: fixed;
  top: 250px;
  background-color: #fff;
  left: 16px;
  width: 300px;
  overflow-x: hidden;
  // transform: translateX(-200%);
  z-index: -1;
  .tree-header {
    height: 24px;
    background-color: #eaeefe;
    .icon-close {
      line-height: 24px;
      float: right;
    }
  }
  .tree-input {
    margin: 5px;
    width: calc(100% - 10px);
  }
  .w-tree {
    height: 580px;
    overflow: auto;
    .w-tree-node__label {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.tree-container {
  z-index: 999;
}
.arrow-tree-container {
  cursor: pointer;
  position: fixed;
  top: 50%;
  left: 0;
  width: 20px;
  height: 20px;
  z-index: 9999;
  .w-icon-triangle-left,
  .w-icon-triangle-right {
    font-size: 20px;
  }
}
.form-version {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.imgNum {
  position: absolute;
  right: 6px;
  top: 6px;
  color: #e49826;
}

.hasIcon {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 28px;
  height: 28px;
  background: url('../../../../../../common/assets/images/ypfj.svg') no-repeat
    100% 100%;
}
.ml {
  margin-left: 6px;
}
.cjs {
  text-align: right;
}
.more_content {
  width: 100%;
  text-align: right;
  margin-top: 10px;
  .more_btn {
    padding: 3px 6px;
    white-space: pre-line;
    word-break: break-all;
    line-height: 22px;
  }
}
.leaders {
  margin-top: 28px;
  position: relative;
  left: 36px;
  .lea {
    margin-left: 8px;
  }
}
.leader {
  // margin-left: 40px;
  margin-top: 4px;
  // position: absolute;
}
.mt-5 {
  margin-bottom: 10px;
}
.checkTables {
  margin-bottom: 50px;
}
.w60 {
  width: 60%;
}
.w40 {
  width: 40%;
}
.w100 {
  width: 100%;
  text-align: left;
}
.flex-center {
  display: flex;
  align-items: center;
}

.flex-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
